document.addEventListener('DOMContentLoaded', () => {
  const showMores = document.querySelectorAll('.js-show-more');

  if (showMores.length > 0) {
      let buttonLabelClosed = 'show more';
      let buttonLabelOpen = 'show less';

      const language = document.documentElement.lang;
      switch (language) {
          case 'nl':
              buttonLabelClosed = 'toon meer';
              buttonLabelOpen = 'toon minder';
              break;
          case 'de':
              buttonLabelClosed = 'zeig mehr';
              buttonLabelOpen = 'zeig weniger';
              break;
          case 'en':
              buttonLabelClosed = 'show more';
              buttonLabelOpen = 'show less';
              break;
          case 'lt':
              buttonLabelClosed = 'rodyti daugiau';
              buttonLabelOpen = 'rodyti mažiau';
              break;
      }

      showMores.forEach((item) => {
          const button = item.querySelector('.js-show-more-button');

          if (!button) return;

          button.addEventListener('click', (e) => {
              e.preventDefault();

              const buttonTextSpan = button.querySelector('span:first-child');
              if (!buttonTextSpan) return;

              if (item.classList.contains('show-more')) {
                  item.classList.remove('show-more');
                  buttonTextSpan.innerHTML = buttonLabelClosed;
              } else {
                  item.classList.add('show-more');
                  buttonTextSpan.innerHTML = buttonLabelOpen;
              }
          });
      });
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/show-more.js